var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg669Cf6A1Cab037Efa533F539(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.08 804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:20px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wazon1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_11",
    "data-name": "Warstwa 11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1184.72,717c2,98.58-6.6,108.86-26.8,159-27,67-93,87-93,87H942s-66-20-93-87c-24.59-61-32-63-24-237,7.18-156.16,106-228,126-296,15.19-51.66-25.6-119.49-46.08-149.09A9.51,9.51,0,0,1,912.75,179h181.41a9.51,9.51,0,0,1,7.83,14.91c-20.48,29.6-61.27,97.43-46.07,149.09,20,68,118.82,139.84,126,296,1.42,31,2.36,56.6,2.8,78",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1094,179",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1293.6,179",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1181,953",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M901,954",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.53,963c.37.57.74,1.14,1.12,1.71",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1053,322c-1.75,57-27.61,88.79-43.8,108.28-17.74,21.35-33.88,27.21-58.58,60a292.69,292.69,0,0,0-34.71,61.07c-20.62,49.15-22,91.5-22.78,124.27C891.25,755.56,910.23,816,920.25,847c10.46,32.35,24.2,73.78,54.81,120",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1036,1000.5",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1091,408c-5.43,39.4-19.73,63.9-32.91,79.52-17.36,20.59-33.16,26.24-57.32,57.83a280.74,280.74,0,0,0-34,58.85c-20.18,47.38-21.54,88.2-22.29,119.78-1.84,77.07,16.73,135.35,26.54,165.21,7.23,22,16.07,48.47,31.23,77.81",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1125.85,461c-5.54,35.53-18.43,58-30.35,72.5-16.35,19.93-31.23,25.4-54,56a273.84,273.84,0,0,0-32,57c-19,45.88-20.29,85.42-21,116-1.73,74.64,15.77,131.08,25,160,3.36,10.53,7.09,22.08,11.72,34.5",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1157,520c-6,27.36-16.47,45.59-26.21,58-15.49,19.7-29.57,25.11-51.12,55.36a273.15,273.15,0,0,0-30.3,56.34c-18,45.35-19.2,84.43-19.88,114.66-1.64,73.77,14.93,129.56,23.67,158.15",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1169.19,514.83",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1179,582c-17.56,20.91-33.53,26.65-58,58.74a285.82,285.82,0,0,0-34.36,59.79c-20.4,48.13-21.78,89.6-22.54,121.68A467.22,467.22,0,0,0,1080.93,957",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1176.64,591.5q-1.58,2.1-3.14,4",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1176.64,591.5",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1179,634.77c-9.45,8.33-19.73,17.59-32.49,34.73a273.84,273.84,0,0,0-32,57c-19,45.88-20.29,85.42-21,116a449.27,449.27,0,0,0,9.2,101.17",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1181.56,632.5l-2.57,2.27",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1185,629.44c-1.14,1-2.28,2-3.44,3.06",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1185,629.44",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1185,668.06a208.28,208.28,0,0,0-13.5,16.44,273.84,273.84,0,0,0-32,57c-19,45.88-20.29,85.42-21,116a446.08,446.08,0,0,0,3.93,70.25",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1185,668.06",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1225.5,628.5",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1185,721a275.86,275.86,0,0,0-22.3,46.3c-16,43.22-17.12,80.46-17.72,109.27q-.27,13.18.17,25.55",
    transform: "translate(-811.92 -169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1188.44,715.84",
    transform: "translate(-811.92 -169)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_13",
    "data-name": "Warstwa 13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M954.28,321.08",
    transform: "translate(-811.92 -169)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg669Cf6A1Cab037Efa533F539);
export default __webpack_public_path__ + "static/media/669cf6a1cab037efa533f539.7763b9a0cdff4f8c4e8ea9d54978866c.svg";
export { ForwardRef as ReactComponent };